/** Convert any string to a URL-safe slug */
export const slugify = (text) =>
  String(text || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

/** Build a descriptive slug for a vehicle: "2019-audi-a3-diesel-saloon" */
export const vehicleSlug = (vehicle) => {
  const parts = [vehicle.year, vehicle.make, vehicle.model, vehicle.fuel, vehicle.bodyType];
  return slugify(parts.filter(Boolean).join(' ')) || 'vehicle';
};

/** Canonical path to a vehicle detail page */
export const vehiclePath = (vehicle) =>
  `/cars/${vehicle.id}/${vehicleSlug(vehicle)}`;

/**
 * Build the best search URL from a filters object.
 * - Make-only  → /stock/audi
 * - Multi-filter → /search?make=Audi&bodyType=SUV&...
 * - No filters  → /inventory
 */
export const buildSearchUrl = (filters) => {
  const { make, bodyType, year, price, transmission, fuel } = filters;
  const hasMake = Boolean(make);
  const hasOther = Boolean(bodyType || year || price || transmission || fuel);

  if (hasMake && !hasOther) {
    return `/stock/${slugify(make)}`;
  }

  const params = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => { if (v) params.set(k, v); });
  const qs = params.toString();
  return qs ? `/search?${qs}` : '/inventory';
};

/** Parse a URLSearchParams object into a filters object */
export const filtersFromSearchParams = (params) => ({
  make: params.get('make') || '',
  bodyType: params.get('bodyType') || '',
  year: params.get('year') || '',
  price: params.get('price') || '',
  transmission: params.get('transmission') || '',
  fuel: params.get('fuel') || '',
});

/**
 * Resolve a make slug (e.g. "land-rover") back to the original make string
 * (e.g. "Land Rover") by scanning the vehicles array.
 */
export const makeFromSlug = (slug, vehicles) =>
  (vehicles || []).find((v) => slugify(v.make) === slug)?.make || '';
